import React from "react"
export const serializers = {
  marks: {
    link: ({ mark, children }) => {
      const { href } = mark
      return (
        <a href={href} target="blank" rel="noopener noreferer">
          {children}
        </a>
      )
    },
  },
}
